import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { styled, css } from 'styled-components';
const Message = styled.span `
  ${({ theme }) => theme.typography.textMedium}
  margin-top: 4px;
  display: inline-flex;
  ${({ error, theme }) => error &&
    css `
      color: ${theme.colors.critical100};
    `}
  ${({ warning, theme }) => warning &&
    css `
      color: ${theme.colors.warning100};
    `}
`;
const AdditionalMessage = ({ message, error }) => (_jsx(Message, { "data-testid": 'warning-message', warning: !error, error: error, children: message }));
export default React.memo(AdditionalMessage);
